import React from "react";
import { CurrentUser as CurrentUserProps } from "../../../stores/CurrentUserStore/Types";
import Notifications from "../../../components/Profile/Notifications";

interface Props {
  currentUser: CurrentUserProps;
  getCurrentUser: () => void;
  handleShowLoggedInSideBar: () => void;
  handleShowNotificationModal: (val: boolean) => void;
  showLoggedInSidebar: boolean;
  showNotificationModal: boolean;
  userXp: number;
}

const CurrentUser: React.FC<Props> = ({
  currentUser,
  getCurrentUser,
  handleShowLoggedInSideBar,
  handleShowNotificationModal,
  showLoggedInSidebar,
  showNotificationModal,
}) => {
  const getAvatarLetters = () => {
    const parts = currentUser.name?.trim().split(/\s+/).filter(Boolean) || [];

    if (parts.length > 1) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }

    const fallbackName = parts[0] || currentUser.short_name || "";
    return `${fallbackName[0] || ""}${
      fallbackName[fallbackName.length - 1] || ""
    }`.toUpperCase();
  };

  const triggerNotificationModal = (e) => {
    e.preventDefault();

    handleShowNotificationModal(!showNotificationModal);
  };

  const triggerLoggedInSidebar = (e) => {
    e.preventDefault();
    e.stopPropagation();

    handleShowLoggedInSideBar();
  };

  return (
    <div className="nav-right">
      <div className="notif-wrap">
        <button
          id="notifBell"
          className="notif-bell"
          type="button"
          onClick={(e) => triggerNotificationModal(e)}
          aria-haspopup="true"
          aria-expanded={showNotificationModal}
          aria-controls="notifDropdown"
          aria-label="Open alerts"
        >
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M18 16v-5a6 6 0 0 0-12 0v5l-2 2v1h16v-1l-2-2z"
            />
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              d="M10 21a2 2 0 0 0 4 0"
            />
          </svg>
          {currentUser.alerts > 0 && (
            <span
              className="notif-dot"
              id="notifDot"
              data-count={currentUser.alerts}
            >
              {currentUser.alerts > 9 ? "9+" : currentUser.alerts}
            </span>
          )}
        </button>
        <Notifications
          currentUser={currentUser}
          getCurrentUser={getCurrentUser}
          showNotificationModal={showNotificationModal}
          handleShowNotificationModal={handleShowNotificationModal}
        />
      </div>

      <div className="nav-divider" />
      <button
        className="profile-trigger"
        id="sidebar_toggle_right"
        type="button"
        onClick={(e) => triggerLoggedInSidebar(e)}
        aria-haspopup="dialog"
        aria-expanded={showLoggedInSidebar}
        aria-controls="account_drawer"
        aria-label={`${currentUser.short_name}, open profile menu`}
      >
        <span className="avatar" aria-hidden="true">
          <img
            src={currentUser?.profile_picture}
            className="user-image"
            alt="profile picture"
          />
        </span>
        <svg className="chev" aria-hidden="true" viewBox="0 0 12 12">
          <path
            d="M2.2 4.4 6 8.2l3.8-3.8"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};
export default CurrentUser;
